import { SHOW_SPINNER, HIDE_SPINNER } from 'actionTypes'

const defaultState = {
  visible: false,
  isReactive: false,
  reactiveCallback: () => {},
  requests:[]
}

const spinner = (state = defaultState, action) => {
  switch (action.type) {
    case SHOW_SPINNER:
      const newRequests = [...state.requests,action.payload]
      return {
        visible: newRequests.length > 0,
        requests: newRequests,
        isReactive: action.isReactive,
        reactiveCallback: action.reactiveCallback
      }

    case HIDE_SPINNER:
      const copy = Array.from(state.requests)
      if (copy.indexOf(action.payload) >= 0) copy.splice(copy.indexOf(action.payload), 1)

      return {
        visible: copy.length > 0,
        requests: copy,
        isReactive: false,
        reactiveCallback: () => {}
      }

    default:
      return state
  }
}

export default spinner
